import React, { Component } from "react";
import { connect } from 'react-redux';
import { Segment, Item, Button } from "semantic-ui-react";
import { Link } from 'react-router-dom';
import format from 'date-fns/format';
import { deleteText } from './userActions';

const actions = {
    deleteText
}
class SavedEntriesItem extends Component {

    render() {
        const { entry, deleteText } = this.props;
        let createdAt;
        if (entry.created) {
            createdAt = format(entry.created, 'H:m M/D/YY');
        }

        return (
            <div style={{ 'marginBottom': '15px' }} >
                <Segment.Group>
                    <Segment>
                        <h5>{entry.content}</h5>
                    </Segment>
                    <Segment clearing>
                        <p className="saved-entry__text">{createdAt}</p>
                        <Button size='mini' color="red" floated="right" content="Delete" onClick={() => deleteText(entry.id)} />

                        <Link to={{
                            pathname: '/play',
                            state: {
                                words: entry.content
                            }
                        }}>
                            <Button size='mini' color="blue" floated="right">Read</Button>
                        </Link>

                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}

export default connect(null, actions)(SavedEntriesItem);


// WEBPACK FOOTER //
// ./src/Components/SavedPage/SavedEntriesItem.jsx